query AnalyticsVisitorsByDate($filter: AnalyticsViewsFilterInput!, $calendarInterval: CalendarInterval) {
  analyticsViews(filter: $filter) {
    visitorsByDate(calendarInterval: $calendarInterval) {
      calendarInterval
      items {
        label
        displayCurrency
        data {
          x
          y
        }
      }
    }
  }
}
